export const TAX_CATEGORIES = ['Normal', 'Intermediate', 'Reduced', 'Exempt', 'Other'];
export const TAXABLE_CATEGORIES = TAX_CATEGORIES.filter((category) => category !== 'Exempt');

export const DEFAULT_VAT_CLASSIFICATION = {
  vatExempt: true,
  taxCategory: 'Exempt',
  vatRate: '',
  vatExemptionReason: '',
};

const readOptional = (source, camel, pascal) => {
  if (!source || typeof source !== 'object') {
    return undefined;
  }

  if (source[camel] !== undefined) {
    return source[camel];
  }

  return source[pascal];
};

export const readVatClassification = (source) => {
  const exempt = readOptional(source, 'vatExempt', 'VatExempt');
  const category = readOptional(source, 'taxCategory', 'TaxCategory');
  const rate = readOptional(source, 'vatRate', 'VatRate');
  const reason = readOptional(source, 'vatExemptionReason', 'VatExemptionReason');

  return {
    vatExempt: exempt == null ? true : Boolean(exempt),
    taxCategory: category || 'Exempt',
    vatRate: rate == null || rate === '' ? '' : String(rate),
    vatExemptionReason: reason || '',
  };
};

export const validateVatClassification = (value) => {
  if (value?.vatExempt !== false) {
    return {};
  }

  const rate = Number(value?.vatRate);
  if (!Number.isFinite(rate) || rate <= 0 || rate > 100) {
    return { vatRate: 'vat.validation.rateRequired' };
  }

  return {};
};

export const toVatPayload = (value) => {
  const classification = readVatClassification(value);
  const vatExempt = classification.vatExempt;
  const reason = String(classification.vatExemptionReason || '').trim();

  return {
    vatExempt,
    taxCategory: vatExempt
      ? 'Exempt'
      : (classification.taxCategory && classification.taxCategory !== 'Exempt'
        ? classification.taxCategory
        : 'Normal'),
    vatRate: vatExempt ? null : Number(classification.vatRate),
    vatExemptionReason: vatExempt ? (reason || null) : null,
  };
};
